// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2veuU","col":"Table_col__1cGLs","fulfillmentStatus":"Table_fulfillmentStatus__2g4Si","emailCol":"Table_emailCol__2_uAW"};